import { Injectable } from '@angular/core';
import {User} from '../../shared/model/user';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {HttpError} from '../../shared/error/http-error';
import {LoginHttpError} from '../http-error/login-http-error';
import {AuthenticationService} from '../../shared/service/authentication.service';
import {HttpService} from '../../shared/service/http.service';

const AUTH_ENDPOINT = '/auth';

@Injectable()
export class LoginService {
  private LOGIN = '/login';

  login$: Observable<User>;
  error$: Observable<HttpError>;

  private loginSubject: Subject<User>;
  private errorSubject: Subject<HttpError>;

  constructor(private _http: HttpService, private authenticationService: AuthenticationService) {
    this.loginSubject = new Subject();
    this.login$ = this.loginSubject.asObservable();
    this.errorSubject = new Subject();
    this.error$ = this.errorSubject.asObservable();
  }

  login(user: User) {
    this._http.post(AUTH_ENDPOINT + this.LOGIN, user, User, LoginHttpError)
      .subscribe(
        loggedUser => {
          this.authenticationService.setUserOnLocalStorage(loggedUser);
          this.loginSubject.next(loggedUser);
        },
        error => this.errorSubject.next(error)
      );
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/login/service/login.service.ts